export const SERVICE_CATEGORIES = [
  { id: 'maintenance', name: 'Home Repairs', value: 'maintenance', label: 'Home Repairs', icon: '🔧' },
  { id: 'painting', name: 'Painting', value: 'painting', label: 'Painting', icon: '🎨' },
  { id: 'electrical', name: 'Electrical', value: 'electrical', label: 'Electrical', icon: '⚡' },
  { id: 'plumbing', name: 'Plumbing', value: 'plumbing', label: 'Plumbing', icon: '🚰' },
  { id: 'flooring', name: 'Flooring', value: 'flooring', label: 'Flooring', icon: '🏠' },
  { id: 'installation', name: 'Appliance Installation', value: 'installation', label: 'Appliance Installation', icon: '📦' },
  { id: 'assembly', name: 'Furniture Assembly', value: 'assembly', label: 'Furniture Assembly', icon: '🪑' },
  { id: 'moving', name: 'Moving Services', value: 'moving', label: 'Moving Services', icon: '🚚' },
  { id: 'renovation', name: 'Renovation', value: 'renovation', label: 'Renovation', icon: '🏗️' },
  { id: 'security', name: 'Safety & Security', value: 'security', label: 'Safety & Security', icon: '🔒' },
  { id: 'cleaning', name: 'Cleaning', value: 'cleaning', label: 'Cleaning', icon: '🧹' },
  { id: 'elderly-care', name: 'Elderly Home Care', value: 'elderly-care', label: 'Elderly Home Care', icon: '💙' }
];

export const SERVICE_CATEGORIES_SIMPLE = SERVICE_CATEGORIES.map(cat => cat.id);

export const SERVICE_CATEGORIES_OBJECT_FORMAT = SERVICE_CATEGORIES.map(cat => ({ id: cat.id, name: cat.name, icon: cat.icon }));

export const SERVICE_CATEGORIES_SELECT_FORMAT = SERVICE_CATEGORIES.map(cat => ({ value: cat.value, label: cat.label }));